<button class="card-button"
        [class.card-button--transparent]="transparent()"
        (click)="onClick.emit()">
    <div class="flex">
        <div class="label">{{ subtitle() }}</div>
        <div class="value">{{ value() }}</div>
    </div>
    <div class="icon-wrapper">
        <img class="rotate" ngSrc="/assets/img/icons/black-arrow.svg"
             priority="true"
             width="24" height="24"
             alt=""/>
    </div>
</button>
